// extracted by mini-css-extract-plugin
export var leftAlign = "_1t-2";
export var popper = "_1t-0";
export var subtitle = "_1t-1";